import { render, staticRenderFns } from "./CheckPermission.vue?vue&type=template&id=161d11f5&scoped=true"
import script from "./CheckPermission.vue?vue&type=script&lang=js"
export * from "./CheckPermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161d11f5",
  null
  
)

export default component.exports